export default "<app-router-tabs [tabTitle]=\"tabTitle\" [navLinks]=\"navLinks\"></app-router-tabs>\n"